import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box } from '@mui/material';
import { t } from 'i18next';
import { Dispatch, FC, FormEvent, SetStateAction, useState } from 'react';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { PcapFileWithCps } from '../types';
import { PcapFilesList } from '@pages/library';

interface AddPcapFilesDialogProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    pcapFilesUsed: PcapFileWithCps[];
    setPcapFilesUsed: Dispatch<SetStateAction<PcapFileWithCps[]>>;
}

const AddPcapFilesDialog: FC<AddPcapFilesDialogProps> = ({ open, setOpen, pcapFilesUsed, setPcapFilesUsed }) => {
    const [pcapFilesSelectedArr, setPcapFilesSelectedArr] = useState<PcapFileWithCps[]>([]);

    const handleClose = () => {
        setPcapFilesSelectedArr([]);
        setOpen(false);
    };

    const handleAddPcapFiles = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setOpen(false);
        setPcapFilesUsed((prev) => [...prev, ...pcapFilesSelectedArr]);
        setPcapFilesSelectedArr([]);
    };

    return (
        <Dialog
            open={open}
            maxWidth={false}
            PaperProps={{
                component: 'form',
                onSubmit: handleAddPcapFiles,
                sx: { height: 750, width: 1750, p: 2 },
            }}
        >
            <DialogTitle sx={{ fontSize: 20 }}>{t('select') + ' ' + t('pcap_files')}</DialogTitle>
            <DialogContent sx={{ height: '100%' }}>
                <PcapFilesList
                    dialogMode
                    pcapFilesUsed={pcapFilesUsed}
                    pcapFilesSelectedArr={pcapFilesSelectedArr}
                    setPcapFilesSelectedArr={setPcapFilesSelectedArr}
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Typography sx={{ color: 'var(--text-secondary)' }}>
                    <Typography component={'span'} sx={{ fontWeight: 700 }}>
                        {pcapFilesUsed.length + pcapFilesSelectedArr.length}
                    </Typography>{' '}
                    {t('pcap_files_r') + ' ' + t('selected')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <UtmsButton type="submit" disabled={!pcapFilesSelectedArr.length}>
                        {t('add')}
                    </UtmsButton>
                    <UtmsButton color="secondary" onClick={handleClose}>
                        {t('cancel')}
                    </UtmsButton>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default AddPcapFilesDialog;
